/*
 * View for configuring and exporting Topic Listings
 */
define(["marionette", "jquery", "tom-select", "./topicListingTemplate.html"], function (
  Marionette,
  $,
  TomSelectModule,
  TopicListingTemplate,
) {
  "use strict";
  const TomSelect = TomSelectModule.default || TomSelectModule;

  const TopicListingView = {};

  TopicListingView.topicListingView = Marionette.ItemView.extend({
    template: TopicListingTemplate,

    events: {
      "click #downloadListing": "onDownloadClick",
    },

    initialize: function () {
      this.touchpoints = this.model.touchpoints;
      this.locales = this.model.locales;
    },

    onRender: function () {
      this.constructor.__super__.onRender.call(this);
      this._initTomSelect("#touchpoints", $.t("reports.placeholder.optional.touchpoints"));
      this._initTomSelect("#locales", $.t("reports.placeholder.optional.languages"));
    },

    _initTomSelect: function (selector, placeholder) {
      const $select = this.$(selector);

      new TomSelect($select[0], {
        plugins: ["remove_button"],
        placeholder,
        hidePlaceholder: true,
        closeAfterSelect: true,
        selectOnTab: true,
      });
    },

    onDownloadClick: function () {
      const tpSelect = this.$el.find("#touchpoints")[0].tomselect;
      const lcSelect = this.$el.find("#locales")[0].tomselect;

      const params = {
        abbreviated: this.$el.find("#abbrev").prop("checked"),
        includeBranchTopics: this.$el.find("#branching").prop("checked"),
        showBlankResponses: this.$el.find("#blank").prop("checked"),
        localeIds: lcSelect.getValue().map((id) => parseInt(id)),
        touchPointIds: tpSelect.getValue().map((id) => parseInt(id)),
        format: this.$el.find("#outputFormat").val(),
      };

      this.trigger("export:listing", params);
    },
  });

  return TopicListingView;
});
